// Google Analytics configuration
const RECIRCLE_GA_ID = "G-53CG91Q9N3";

// Detect if we're on ClimaOne domain (skip analytics for these)
const CLIMAONE_HOSTS = new Set(["climaonev2.recircle.in", "www.climaonev2.recircle.in"]);
const isClimaOneHost = () => {
  if (typeof window === 'undefined') return false;
  return CLIMAONE_HOSTS.has(window.location.hostname.toLowerCase());
};

export const initializeGoogleAnalytics = () => {
  // Skip analytics completely for ClimaOne domains
  if (isClimaOneHost()) {
    console.log('Analytics skipped for ClimaOne domain');
    return;
  }

  // Only initialize in production and if not already loaded
  if (process.env.NODE_ENV !== 'production' || window.gtag) {
    return;
  }

  try {
    // Create and append the Google Analytics script
    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${RECIRCLE_GA_ID}`;
    document.head.appendChild(script);

    // Initialize dataLayer and gtag function
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }

    // Make gtag available globally
    window.gtag = gtag;

    // Configure Google Analytics
    gtag("js", new Date());
    gtag("config", RECIRCLE_GA_ID, {
      // Enhanced privacy settings
      anonymize_ip: true,
      cookie_flags: 'SameSite=Strict;Secure'
    });

    console.log('Google Analytics initialized for ReCircle Foundation');
  } catch (error) {
    console.warn('Failed to initialize Google Analytics:', error);
  }
};

// Track page views
export const trackPageView = (path) => {
  // Skip tracking for ClimaOne domains
  if (isClimaOneHost()) return;
  
  if (window.gtag && process.env.NODE_ENV === 'production') {
    window.gtag('config', RECIRCLE_GA_ID, {
      page_path: path,
    });
  }
};

// Track custom events
export const trackEvent = (action, category = 'engagement', label = '', value = 0) => {
  // Skip tracking for ClimaOne domains
  if (isClimaOneHost()) return;
  
  if (window.gtag && process.env.NODE_ENV === 'production') {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value,
    });
  }
};